import React, { useState } from "react";

import "../../styles/PlacedByTable.css";

const PlacedByTable = ({ data }) => {

    const [
        selectedData,
        setSelectedData
    ] = useState(null);

    // ============================================
    // SORT MONTH ORDER
    // ============================================

    const sortedData = [...data].sort(
        (a, b) => {

            const dateA =
                new Date(`01 ${a.month}`);

            const dateB =
                new Date(`01 ${b.month}`);

            return dateA - dateB;
        }
    );

    // ============================================
    // GET UNIQUE OFFICERS
    // ============================================

    const officers = [
        ...new Set(
            sortedData.map(
                item => item.placedBy
            )
        )
    ];

    // ============================================
    // TRANSFORM TABLE
    // ============================================

    const groupedData = {};

    sortedData.forEach(item => {

        if (!groupedData[item.month]) {

            groupedData[item.month] = {
                month: item.month,
                total: 0
            };

            officers.forEach(officer => {

                groupedData[item.month][officer] = {
                    total: 0,
                    branches: []
                };
            });
        }

        groupedData[item.month][item.placedBy] = {

            total: item.total,

            branches:
                item.branches || []
        };

        groupedData[item.month]
            .total += item.total;
    });

    const finalTableData =
        Object.values(groupedData);

    return (

        <div className="placement-summary-container">

            <h3 className="placement-summary-title">
                Placement Officer Summary
            </h3>

            <table className="placement-summary-table">

                <thead>

                    <tr>

                        <th>
                            Month
                        </th>

                        {officers.map(
                            officer => (

                            <th key={officer}>
                                {officer}
                            </th>
                        ))}

                        <th>
                            Total
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {finalTableData.map(
                        (
                            row,
                            index
                        ) => (

                        <tr key={index}>

                            <td className="month-cell">
                                {row.month}
                            </td>

                            {officers.map(
                                officer => {

                                const officerData =
                                    row[officer];

                                return (

                                    <td
                                        key={officer}
                                        className="count-cell"
                                    >

                                        <span
                                            className="placement-count-link"
                                            onClick={() =>
                                                setSelectedData({

                                                    month:
                                                        row.month,

                                                    officer,

                                                    ...officerData
                                                })
                                            }
                                        >

                                            {
                                                officerData.total
                                            }

                                        </span>

                                    </td>
                                );
                            })}

                            <td className="total-cell">

                                <strong>
                                    {row.total}
                                </strong>

                            </td>

                        </tr>
                    ))}

                </tbody>

            </table>

            {/* ============================================
                BRANCH BREAKDOWN
            ============================================ */}

            {selectedData && (

                <div className="branch-breakdown-container">

                    <div className="branch-breakdown-header">

                        <h3 className="branch-breakdown-title">

                            {selectedData.month}
                            {" - "}
                            {selectedData.officer}

                        </h3>

                        <button
                            className="close-breakdown-btn"
                            onClick={() =>
                                setSelectedData(null)
                            }
                        >
                            ✕ Close
                        </button>

                    </div>

                    <table className="branch-breakdown-table">

                        <thead>

                            <tr>

                                <th>
                                    Branch
                                </th>

                                <th>
                                    Count
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {selectedData.branches.map(
                                (
                                    branch,
                                    idx
                                ) => (

                                <tr key={idx}>

                                    <td>
                                        {
                                            branch.branch
                                        }
                                    </td>

                                    <td>
                                        {
                                            branch.count
                                        }
                                    </td>

                                </tr>
                            ))}

                            <tr className="branch-total-row">

                                <td>

                                    <strong>
                                        Total
                                    </strong>

                                </td>

                                <td>

                                    <strong>
                                        {
                                            selectedData.total
                                        }
                                    </strong>

                                </td>

                            </tr>

                        </tbody>

                    </table>

                </div>
            )}

        </div>
    );
};

export default PlacedByTable;